import { render, staticRenderFns } from "./CompanyTable.vue?vue&type=template&id=3000035f&"
import script from "./CompanyTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports